import React from 'react'

export const APP_NAME = 'React Starter'

interface IProps {
  children: React.ReactNode
  pageKey?: string
}

export default function Page({ children }: IProps) {
  return children
}
